<template>
  <div>
    <b-btn
      :id="`itemCheckListBtn${itemId}`"
      pill
      variant="none"
      style="padding:0.4rem;"
      :class="`btn-outline-${(nomeArquivoSelecionado && nomeArquivoSelecionado !== '') || (nomeArquivo && nomeArquivo !== '') ? 'primary' : 'secondary'}`"
      @click="mostrarPopover = true"
    >
      <feather-icon
        icon="PaperclipIcon"
      />
    </b-btn>

    <b-popover
      :id="'AnexoheckList'"
      ref="AnexoCheckList"
      placement="auto"
      :target="`itemCheckListBtn${itemId}`"
      triggers="hover"
      :show.sync="mostrarPopover"
    >
      <div slot="title">
        <span
          class="text-center"
          style="vertical-align: sub"
        >Anexo da Pergunta</span>

        <b-button
          variant="none"
          class="close "
          @click="cancelar"
        >
          <span aria-hidden="true">&times;</span>
        </b-button>
      </div>
      <div>
        <b-row>
          <b-col />
        </b-row>
        <b-row>
          <b-col
            cols="12"
            style="margin-bottom: 0.5rem"
          >
            <b-btn
              class="btn-success btn-sm w-100"
              :disabled="!visualizarArquivo"
              @click="visualizar()"
            >Visualizar</b-btn>
          </b-col>
          <b-col
            cols="12"
            style="margin-bottom: 0.5rem"
          >
            <b-btn
              v-if="adicionarEditar"
              class="btn-success btn-sm w-100"
              :disabled="desabilitar"
              @click="editar()"
            >Adicionar</b-btn>
            <b-btn
              v-else
              class="btn-success btn-sm w-100"
              :disabled="desabilitar"
              @click="editar()"
            >Editar</b-btn>
          </b-col>
          <b-col
            cols="12"
            style="margin-bottom: 0.5rem"
          >
            <b-btn
              class="btn-success btn-sm w-100"
              :disabled="!deletarArquivo || desabilitar"
              @click="remover()"
            >Remover</b-btn>
          </b-col>
        </b-row>

      </div>
    </b-popover>

    <visualizar-arquivo
      v-if="mostrarVisualizacaoArquivo"
      :url="urlArquivo"
      @hidden="fecharVisualizarArquivo()"
    />

    <upload-anexos-check-list
      v-if="mostrarUploadProcedimentos"
      ref="upload"
      :value="form.arquivoProcedimento"
      @cancelar="cancelarUpload()"
      @hidden="aplicarUpload($event)"
    />
  </div>
</template>

<style lang="scss">
.modal-upload-title {
  margin: 0px;
  font-size: 20px;
}

.vertical-buttons {
  flex-direction: column-reverse;
}

.top-margin {
  margin-top: 1em;
}
</style>

<script src="sweetalert2.all.min.js"></script>
<script>
import api from '@/app-modulo/comercial/cadastro-proposta/shared/services/api'

export default {
  name: 'AnexoItemCheckList',
  components: {
    UploadAnexosCheckList: () => import('@/app-modulo/comercial/cadastro-proposta/shared/components/checklist-proposta/shared/components/UploadAnexoCheckList.vue'),
    VisualizarArquivo: () => import('@/shared/components/visualizar-arquivo/VisualizarArquivo.vue')
  },
  props: {
    geradoProposta: {
      type: Boolean,
      default: false,
    },
    itemId: {
      type: [Number, String],
      default: 0,
    },
    propostaId: {
      type: Number,
      default: 0,
    },
    nomeArquivo: {
      type: String,
      default: '',
    },
    externo: {
      type: Boolean,
      default: false,
    },
    desabilitar: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      existeAnexoItem: false,
      mostrarPopover: false,
      mostrarUploadProcedimentos: false,
      mostrarVisualizacaoArquivo: false,
      urlArquivo: '',
      deletarArquivo: false,
      visualizarArquivo: false,
      adicionarEditar: true,
      form: {
        Id: 0,
        PropostaId: 0,
        ArquivoItemCheckList: null,
        nomeArquivo: '',
        arquivoRequest: null,
      },
      nomeArquivoSelecionado: '',
    }
  },
  created() {
    this.form.PropostaId = this.propostaId
    this.form.Id = parseInt(this.itemId)
    if (this.nomeArquivo != null && this.nomeArquivo != '') {
      this.adicionadoArquivo()
      this.adicionarEditar = false
    } else {
      this.arquivoDeletado()
    }
  },
  methods: {
    cancelar() {
      this.mostrarPopover = false
      this.$emit('cancel')
    },
    editar() {
      this.mostrarUploadProcedimentos = true
    },
    remover() {
      if (this.form.Id > 0) {
        api.deleteAnexoItemCheckList(this.form.Id, this.externo)
        .then(payload => {
          if (payload.data) {
            this.$swal({
              icon: 'success',
              title: 'Removido!',
              text: 'Anexo removido com sucesso.',
              customClass: {
                confirmButton: 'btn btn-success',
              },
            })
            this.arquivoDeletado()
          } else {
            this.$swal({
              icon: 'info',
              title: '',
              text: 'Não há anexo no Item.',
              customClass: {
                confirmButton: 'btn btn-success',
              },
            })
          }
        })
        .catch(err => {
          throw err
        })
      } else {
        this.nomeArquivoSelecionado = ''
        this.deletarArquivo = false
        this.$emit('remover-arquivo')
      }
    },
    visualizar() {
      api.getURLItemCheckList(this.form.Id, this.externo)
        .then(payload => {
          if (payload.data) {
            this.urlArquivo = payload.data
            this.mostrarPopover = false
            this.mostrarVisualizacaoArquivo = true
          } else {
            this.$swal({
              icon: 'info',
              title: '',
              text: 'Não há anexo no item.',
              customClass: {
                confirmButton: 'btn btn-success',
              },
            })
          }
        })
        .catch(err => {
          throw err
        })
    },
    fecharVisualizarArquivo() {
      this.mostrarVisualizacaoArquivo = false
    },
    aplicarUpload(file) {
      const axios = require('axios')
      let uploadCancelado = false
      this.nomeArquivoSelecionado = file.name
      const form = { ...this.form }

      const formData = this.$refs.upload.getFormDataBody(file, form)

      if (this.geradoProposta) {
        const swal = require('sweetalert2')
        swal.fire({
          title: 'Aguarde, estamos enviando o arquivo para o servidor!',
          willOpen () {
            swal.showLoading()
          },
          didClose () {
            if (swal.DismissReason.cancel) {
              uploadCancelado = true
              api.abortarUpload()
            } else {
              swal.hideLoading()
            }
          },
          showConfirmButton:false,
          showCancelButton: true,
          allowOutsideClick: false,
          allowEscapeKey: false,
          allowEnterKey: false,
          cancelButtonText: 'Cancelar',
          reverseButtons: true,
          customClass: {
            actions: 'vertical-buttons',
            title: 'modal-upload-title',
            cancelButton: 'top-margin'
          }
        })

        api.addAnexoItemCheckList(formData, axios.CancelToken, this.externo)
          .then(() => {
            swal.close()
            this.$swal({
              icon: 'success',
              title: 'Sucesso',
              text: 'Anexo salvo com sucesso!',
              customClass: {
                confirmButton: 'btn btn-success',
              },
            })
            this.adicionadoArquivo()
          })
          .catch(err => {
            swal.close()
            if (!uploadCancelado){
              if (!err || typeof err.response === 'undefined') {
                this.$confirmar('Erro', 'Tamanho do arquivo excedeu o limite de 512mb', 'error', '')
              } else {
                this.$handleError(err)
              }
            }
            throw err
          })
        this.mostrarUploadProcedimentos = false
      } else {
        this.$emit('add-file', file)
        this.deletarArquivo = true
        this.mostrarUploadProcedimentos = false
      }
    },
    cancelarUpload() {
      this.mostrarUploadProcedimentos = false
    },
    arquivoDeletado() {
      this.deletarArquivo = false
      this.visualizarArquivo = false
      this.adicionarEditar = true
    },
    adicionadoArquivo() {
      this.deletarArquivo = true
      this.visualizarArquivo = true
      this.adicionarEditar = false
    }
  },
}
</script>
